import { render, staticRenderFns } from "./CommissionTable.vue?vue&type=template&id=f495db10&scoped=true"
import script from "./CommissionTable.vue?vue&type=script&lang=js"
export * from "./CommissionTable.vue?vue&type=script&lang=js"
import style0 from "./CommissionTable.vue?vue&type=style&index=0&id=f495db10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f495db10",
  null
  
)

export default component.exports